var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-img',{attrs:{"src":require('@/assets/avtala-logo-medium.png'),"contain":"","max-width":"400","min-height":"120","width":"100%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }